import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { TYPO } from "styles/Typo";
import { CommnetComponentsType } from "types/main";
import VirtualProfile from "../VirtualProfile";
import { useMainCommentListContext } from "../../MainCommentList";
import { useDebateDetailContext } from "contexts/DebateDetailContext";

function DebateUser({
  data,
  type,
}: {
  data: CommentItem;
  type: CommnetComponentsType;
}) {
  const created_at = data?.created_at;
  const updated_at = data?.updated_at;

  const mainCommentListContext = useMainCommentListContext();
  const debateDetailContext = useDebateDetailContext();

  const isOwnerComment = mainCommentListContext
    ? mainCommentListContext?.parentUser === data?.email
    : debateDetailContext
    ? debateDetailContext?.opinionData?.email === data?.email
    : false;

  function formatTimeDiffKST(dateString: string) {
    if (!dateString) return "";
    const normalized = dateString.trim().replace(" ", "T");
    // API는 KST naive 문자열. TZ 없으면 UTC 서버/SSR에서 미래로 파싱되어 "-N분 전"이 된다.
    const hasTz = /[zZ]|[+-]\d{2}:?\d{2}$/.test(normalized);
    const inputDate = new Date(hasTz ? normalized : `${normalized}+09:00`);

    const diffMs = Date.now() - inputDate.getTime();
    const diffMinutes = Math.floor(diffMs / (60 * 1000));
    const diffHours = Math.floor(diffMs / (60 * 60 * 1000));
    const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));

    if (!Number.isFinite(diffMinutes) || diffMinutes < 1) return "방금 전";
    if (diffMinutes < 60) return `${diffMinutes}분 전`;
    if (diffHours < 24) return `${diffHours}시간 전`;
    return `${diffDays}일 전`;
  }

  return (
    <div
      className="flex items-center w-full gap-1"
      data-test-id={`debate-user-${data?.comment_id}`}
    >
      {type === "optionDetail" && (
        <VirtualProfile data={data} isMyComment={false} />
      )}
      <span
        data-test-id={`debate-user-name-${data?.comment_id}`}
        className={
          type === "optionDetail"
            ? `${TYPO.TYPO8_SB} text-gray50`
            : `${TYPO.TYPO8_MD} text-gray70`
        }
      >
        {data?.nickname}
      </span>
      <span className={`${TYPO.TYPO9_RG} text-gray40`}>
        {type === "optionDetail" ? "・" : ""}
        {formatTimeDiffKST(created_at)}
      </span>
      {updated_at && (
        <span
          data-test-id="debate-user-modified"
          className={`${TYPO.TYPO9_RG} text-gray40`}
        >
          {"(수정됨)"}
        </span>
      )}
      {type === "comment" && isOwnerComment && (
        <span className={`${TYPO.TYPO9_MD} text-blue40`}>{"∙ 작성자"}</span>
      )}
    </div>
  );
}

export default DebateUser;
